import React, { useMemo } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import { Wizard } from '@divvy-web/skylab.form'
import { useFormContext, useWatch } from '@divvy-web/skylab.react-hook-form'

import AnnualRevenueQuestion from './AnnualRevenueQuestion'
import CreditRangeQuestion from './CreditRangeQuestion'
import CurrentCashQuestion from './CurrentCashQuestion'
import GoodFitWizardFormFooter from './GoodFitWizardFormFooter/GoodFitWizardFormFooter'
import styles from './styles.module.scss'

interface GoodFitWizardFormProps {
  isScreeningForCreditApplication: boolean
}

const GoodFitWizardForm = ({ isScreeningForCreditApplication }: GoodFitWizardFormProps) => {
  const [getClassName] = useNameFormatter('GoodFitWizardForm')
  const { control } = useFormContext()
  const currentStep = useWatch({ control, name: '__currentStep' })
  const stepTuples = useMemo(
    () => [
      [AnnualRevenueQuestion, null],
      [CurrentCashQuestion, null],
      [CreditRangeQuestion, null],
    ],
    [],
  )
  return (
    <div className={styles[getClassName('')]}>
      <Wizard
        currentStep={currentStep}
        footer={<GoodFitWizardFormFooter isScreeningForCreditApplication={isScreeningForCreditApplication} />}
        // @ts-expect-error
        stepTuples={stepTuples}
        title={
          <FormattedMessage
            defaultMessage="Let's see if we're a good fit"
            id='sputnik.GoodFitWizardForm__34BKUa'
          />
        }
        totalSteps={stepTuples.length}
      />
    </div>
  )
}

export default GoodFitWizardForm
